import { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';
import Page from 'components/common/Page';
import { ProductName } from 'domain/product/enums/ProductName';
import PageHeading from 'components/common/Product/PageHeading';

const AlertsOutlet: FunctionComponent = () => (
	<Page>
		<PageHeading product={ProductName.Alerts} />
		<Outlet />
	</Page>
);

export default AlertsOutlet;
